module.exports = __webpack_public_path__ + "static/userFeedback-864d98a77f9d7aeb8f7b226539000b7b.gif";